import React, { createContext, useContext, useEffect, useState } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';

const GET_ID_SEQ = gql`
  query GetIdSeq($type: String!) {
    tbl_id_SEQ(where: { type: { _eq: $type } }) {
      id_seq
    }
  }
`;

const UPDATE_ID_SEQ = gql`
  mutation UpdateIdSeq($type: String!, $id_seq: Int!) {
    update_tbl_id_SEQ(
      where: { type: { _eq: $type } }
      _set: { id_seq: $id_seq }
    ) {
      returning {
        id_seq
      }
    }
  }
`;


/*const IdSeqContext = createContext();

const [updateIdSeq] = useMutation(UPDATE_ID_SEQ2);

export const IdSeqProvider = ({ children }) => {
  const [idSeq, setIdSeq] = useState(0);

  const updateIdSeq = async (type) => {
    // Burada GraphQL veya diğer güncelleme mantıklarınızı ekleyin
    // Ve güncellenmiş id_seq'i alın
    const updatedIdSeq = await performUpdateIdSeq(type);

    // Güncellenmiş id_seq'i state'e kaydedin
    setIdSeq(updatedIdSeq);

    return updatedIdSeq;
  };

  return (
    <IdSeqContext.Provider value={{ idSeq, updateIdSeq }}>
      {children}
    </IdSeqContext.Provider>
  );
};

export const useIdSeqUpdater = () => {
  const context = useContext(IdSeqContext);

  if (!context) {
    throw new Error('useIdSeqUpdater IdSeqProvider içinde kullanılmalıdır');
  }

  return context.updateIdSeq;
};

export const useIdSeq = () => {
  const context = useContext(IdSeqContext);

  if (!context) {
    throw new Error('useIdSeq IdSeqProvider içinde kullanılmalıdır');
  }

  return context.idSeq;
};*/




export const YourComponentContext = createContext();

export const useYourComponentContext = () => useContext(YourComponentContext);

export function YourComponentProvider({ type, children }) {
  const { loading, error, data } = useQuery(GET_ID_SEQ, {
    variables: { type },
  });

  const [updateIdSeq] = useMutation(UPDATE_ID_SEQ);
  const [newId, setNewId] = useState(null);

  // Sorgu ve mutasyon işlemlerini tetiklemek için bir fonksiyon oluşturun
  const triggerQueryAndMutation = async (type, id_seq) => {
    console.log('TYPE:', type);
    console.log('ID_SEQ:', id_seq);
    
    if (!loading && !error && data) {
      console.log('ID_SEQ:', data.tbl_id_SEQ[0].id_seq);

      const updatedId = data.tbl_id_SEQ[0].id_seq + 1;
      try {
        const result = await updateIdSeq({
          variables: { type, id_seq: updatedId },
        });
        const updatedIdFromMutation = result.data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log('ID_SEQ güncellendi:', updatedIdFromMutation);
        setNewId(updatedIdFromMutation);
        console.log('ID:', updatedIdFromMutation);
      } catch (mutationError) {
        console.error('Hata:', mutationError);
      }
    }
  };

  useEffect(() => {
    // ...
  }, [loading, error, data, type, updateIdSeq]);

  // Context değerlerini ve işlevi döndürün
  const contextValue = {
    newId,
    setNewId,
    triggerQueryAndMutation, // Sorgu ve mutasyon işlemlerini tetiklemek için ekledik
  };

  return (
    <YourComponentContext.Provider value={contextValue}>
      {children}
    </YourComponentContext.Provider>
  );
} 
